<template>
  <div v-if="show" class="dialog active" @mousewheel="mousewheelFn">
    <van-icon v-if="showClose" class="close" @click="closeFn" name="close" />
    <div
        class="wrap"
        ref="wrap"
    >
      <div
          class="pdfWrap"
          id="pdfWrap"
          ref="dragBox"
          @touchstart="touchstartHandle('dragBox',$event)"
          @touchmove="touchmoveHandle('dragBox',$event)"

          :style="{cursor: 'pointer', transform: `rotate(${rotate}deg)`,width: `${scale}%`,top:position.y+'px', left:position.x+'px'}"
      >
        <pdf
            v-if="pdfSrc"
            :src="pdfSrc"
            :page="currentPage"
            ref="pdf"
            @num-pages="pageCount=$event"
            @page-loaded="currentPage=$event"
            @loaded="loadPdfHandler"
        ></pdf>
      </div>
      <div class="control">
<!--        ,'原图(1:1)','向左旋转90°','向右旋转90°'-->
        <a
            v-for="(item,index) in [{ title: '放大(+)', icon: 'plus' },
            { title: '缩小(-)', icon: 'minus' },
            { title: '上一页' , icon: 'arrow-left' },
            { title: '下一页', icon: 'arrow' }]"
            :key="index"
            @click="handle(index)"
            :title="item.title"
        >
          <van-icon :name="item.icon" />
        </a>
      </div>
      <div :class="{toast:true,showToast,animate}">{{toastScale}}</div>
    </div>
  </div>
</template>

<script>
// import { bind, unbind, objDrag } from "../../utils/pdf/pdf";
import pdf from "vue-pdf";
export default {
  name: "Pdf",
  data() {
    return {
      initPosX: 0,
      initPosY: 0,
      pdfSrc: "",
      currentPage: 0, // pdf文件页码
      pageCount: 0, // pdf文件总页数
      numPages: 1,
      activeIndex: 0,
      iWidth: document.documentElement.clientWidth,
      iHeight: document.documentElement.clientHeight,
      scale: 50,
      rotate: 0,
      scaleAdd: 20,
      rotateAdd: 90,
      showToast: false,
      animate: false,
      toastTimer1: null,
      toastTimer2: null,
      objDrag: null,


      flags: false,
      position: {
        x: 320,
        y: 60
      },

      coordinate: {
        client: {},
        elePosition: {}
      }

    };
  },

  created() {

  },

  computed: {
    toastScale() {
      let { scale } = this;
      return `${scale}%`;
    }
  },

  props: {
    parent: {
      //父组件的this
      type: Object,
      default: null,
      required: true
    },
    show: {
      //是否显示组件
      type: Boolean,
      default: false
    },
    showName: {
      //控制显示组件的名称
      type: String,
      default: ""
    },
    showClose: {
      //是否显示组件关闭按钮
      type: Boolean,
      default: true
    },
    dochref: {
      //pdfurl
      type: String,
      default: ""
    },
    currentPages: {
      type: Number,
      default: 1
    }
  },
  components: {
    pdf
  },
  beforeDestroy() {
    // unbind(window, "resize", this.initPos);
  },
  mounted() {
    //图片加上拖拽
    // bind(window, "resize", this.initPos);
    this.pdfSrc = this.dochref;
  },
  methods: {

    touchstartHandle(refName, e) {
      let element = e.targetTouches[0]
      // 记录点击的坐标
      this.coordinate.client = {
        x: element.clientX,
        y: element.clientY
      }
      // 记录需要移动的元素坐标
      this.coordinate.elePosition.left = this.$refs[refName].offsetLeft
      this.coordinate.elePosition.top = this.$refs[refName].offsetTop
    },
    touchmoveHandle(refName, e) {
      let element = e.targetTouches[0]
      // 根据初始 client 位置计算移动距离(元素移动位置=元素初始位置+光标移动后的位置-光标点击时的初始位置)
      let x = this.coordinate.elePosition.left + (element.clientX - this.coordinate.client.x)
      let y = this.coordinate.elePosition.top + (element.clientY - this.coordinate.client.y)
      // 限制可移动距离，不超出可视区域
      // x = x <= 0 ? 0 : x >= innerWidth - this.$refs[refName].offsetWidth ? innerWidth - this.$refs[refName].offsetWidth : x
      // y = y <= 0 ? 0 : y >= innerHeight - this.$refs[refName].offsetHeight ? innerHeight - this.$refs[refName].offsetHeight : y
      // 移动当前元素
      this.$refs[refName].style.left = x + 'px'
      this.$refs[refName].style.top = y + 'px'
    },

    initPos() {
      let pdfWrap = document.getElementById("pdfWrap");
      this.iWidth = document.documentElement.clientWidth;
      this.iHeight = document.documentElement.clientHeight;
      // eslint-disable-next-line no-unused-vars
      let width = pdfWrap.clientWidth;
      // eslint-disable-next-line no-unused-vars
      let height = pdfWrap.clientHeight;
      this.initPosX = this.iWidth / 4;
      this.initPosY = this.iHeight / 8;
      this.scale = 100;
      this.rotate = 0;
      // pdfWrap.style.left = this.initPosX + "px";
      // pdfWrap.style.top = this.initPosY + "px";
      pdfWrap.style.left = "50%";
      pdfWrap.style.top = "50%";
      pdfWrap.style.transform= "translate(-50%, -50%)";
    },
    changePdfPage(val) {
      console.log(123)
      if (val === 0 && this.currentPage > 1) {
        this.currentPage--;
      }
      if (val === 1 && this.currentPage < this.pageCount) {
        this.currentPage++;
      }
    },
    // eslint-disable-next-line no-unused-vars
    loadPdfHandler(e) {
      console.log(123)
      this.currentPage = this.currentPages; // 加载的时候先加载第一页
      this.drag("pdfWrap");
      this.initPos();
    },
    closeFn() {
      let { parent, showName } = this;
      if (parent && showName && parent[showName]) {
        parent[showName] = false;
        this.scale = 50;
        this.rotate = 0;
      }
    },
    showToastFn() {
      this.showToast = true;
      this.animate = false;
      clearTimeout(this.toastTimer1);
      clearTimeout(this.toastTimer2);
      this.toastTimer1 = setTimeout(() => {
        this.animate = true;
        this.toastTimer2 = setTimeout(() => {
          this.showToast = false;
          this.animate = false;
        }, 300);
      }, 300);
    },
    magnify() {
      let { scale } = this;
      scale += this.scaleAdd;
      scale = scale > 1000 ? 1000 : scale;
      this.showToastFn();
      this.scale = scale;
    },
    shrink() {
      let { scale } = this;
      scale -= this.scaleAdd;
      scale = scale < 10 ? 10 : scale;
      this.showToastFn();
      this.scale = scale;
    },
    handle(index) {
      // eslint-disable-next-line no-unused-vars
      let { scale, rotate } = this;
      switch (index) {
        case 0:
          this.magnify();
          break;
        case 1:
          this.shrink();
          break;
        // case 2:
        //   this.initPos();
        //   break;
        // case 3:
        //   this.rotate -= this.rotateAdd;
        //   break;
        // case 4:
        //   this.rotate += this.rotateAdd;
        //   break;
        // case 5:
        //   this.changePdfPage(0);
        //   break;
        // case 6:
        //   this.changePdfPage(1);
        //   break;
        case 2:
          this.changePdfPage(0);
          break;
        case 3:
          this.changePdfPage(1);
          break;
      }
    },
    mousewheelFn(ev) {
      console.log(ev)
      let up = true;
      if (ev.wheelDelta) {
        up = ev.wheelDelta > 0 ? true : false;
      } else {
        up = ev.detail < 0 ? true : false;
      }
      if (up) {
        this.magnify();
      } else {
        this.shrink();
      }
    },
    drag(obj) {
      console.log(obj)
      // this.objDrag = new objDrag(obj);
    }
  }
};
</script>

<style lang="less" scoped>

.close{
  font-size: 20px;
  color: white;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 100;
  cursor: pointer;
}

.wrap {
  width: 100%;
  height: 100%;
  position: relative;

  .pdfWrap {
    position: absolute;
  }

  .control {
    display: flex;
    justify-content: center;
    align-items: center;
    //width: 300px;
    padding: 5px 0;
    height: 30px;
    background-color: rgba(255, 255, 255, 0.9);
    border-radius: 25px;
    position: absolute;
    left: 50%;
    margin-left: -150px;
    bottom: 4%;

    a {
      width: 20px;
      margin: 0 5px;
      height: 20px;
      background: no-repeat center center;
      background-size: 16px;
    }
  }
}

.dialog {
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  position: fixed;
  left: 0;
  top: 0;
  z-index: 1999;
  //display: none;
  .active {
    display: block;
  }
  .close {
    right: 3%;
    top: 2%;
  }
  .wrap {
    width: 100%;
    height: 100%;
    position: relative;
    .pdfWrap {
      position: absolute;
    }
    .control {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 300px;
      padding: 5px 0;
      height: 30px;
      background-color: rgba(255, 255, 255, 0.9);
      border-radius: 25px;
      position: absolute;
      left: 50%;
      margin-left: -150px;
      bottom: 4%;
      a {
        width: 20px;
        margin: 0 5px;
        height: 20px;
        background: no-repeat center center;
        background-size: 16px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 18px;
      }
    }
    .toast {
      width: 100px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      background-color: rgba(255, 255, 255, 0.9);
      border-radius: 15px;
      position: absolute;
      top: 30px;
      left: 50%;
      margin-left: -50px;
      z-index: 10;
      transition: opacity 0.3s ease-out;
      opacity: 1;
      display: none;
      .showToast {
        display: block;
      }
      .animate {
        opacity: 0;
      }
    }
  }
}
</style>


